var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{attrs:{"align-center":"","column":""}},[_vm._t("title",[_c('strong',{directives:[{name:"show",rawName:"v-show",value:(_vm.title),expression:"title"}],class:_vm.$_themeTextColorClass},[_vm._v(" "+_vm._s(_vm.title)+" ")])]),_vm._t("default",null,{"options":{
    chartWidth: _vm.chartWidth,
    chartExtend: _vm.chartExtend,
    textStyle: { color: _vm.$_themeTextColor },
  }})],2)}
var staticRenderFns = []

export { render, staticRenderFns }